/* eslint-disable */
import React, { useEffect, useRef } from "react";
import "./styles.scss";
import { connect, useDispatch } from "react-redux";
import { emptyPassedParams, setSearchValue } from "../../actions/screen";
import {
  cancelSubscription,
  clearUser,
  clearUserData,
  getUser,
  getUserPlanStatuses,
  getUserPlanTypes,
  removeUser,
  updateUser,
} from "../../actions/users";
import ClientFilter from "../../components/dialog/clientFilter";
import ConfirmationDialog from "../../components/dialog/confirmationDialog";
import ClientItem from "../../components/items/clientItem";
import Loader from "../../components/loader";
import ClientModal from "../../components/modal/clientModal";
import SearchBlock from "../../components/table/searchBlock";
import { CANCEL_SUBSCRIPTION, REMOVE_USER } from "../../constants/actionTypes";
import { useShowToast } from "../../hooks";
import { strings } from "../../I18n";
import "react-tabs/style/react-tabs.css";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { clearCreateCoupon, getAllCouponByUserId } from "../../actions/cities";
import { getTags } from "../../apis/tags/tag-apis";
import BlockUserModal from "../../components/modal/blockUserModal";
import CancelSubscriptionModal from "../../components/modal/cancelSubscriptionModal";
import PreviewCouponModal from "../../components/modal/previewCouponModal";
import UnblockUserModal from "../../components/modal/unblockUserModal";
import {
  BLOCK_USER,
  SHOW_COUPON,
  SHOW_LEDGER,
} from "../../constants/menuActions";
import { getCurrentUser } from "../../utils/firebase";

function ClientContainer(props) {
  const {
    orderProps,
    changePage,
    searchValue,
    changeSearch,
    clearSearchValue,
    filterProps,
    citiesList,
    getUserSuccess,
    user,
    clearUser,
    updateUser,
    updateUserSuccess,
    getUserPlanStatuses,
    getUserPlanTypes,
    getPlanTypesSuccess,
    clearUserData,
    planTypes,
    planStatuses,
    getClientsSuccess,
    cancelSubscriptionSuccess,
    getCouponListByUser,
    getCouponListByUserSuccess,
    deleteCouponByIdSuccess,
    tagFilterTotalCount,
    currentPageValue,
    adminDetails,
  } = props;

  const dispatch = useDispatch();
  const { id, cityId } = useParams();

  const [confirmDialogVisible, setConfirmDialogVisible] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [blockModalVisible, setBlockModalVisible] = React.useState(false);
  const [unblockModalVisible, setUnblockModalVisible] = React.useState(false);
  const [filterVisible, setFilterVisible] = React.useState(false);
  const [filterValues, setFilterValues] = React.useState([]);
  const [userInfoModalVisible, setUserInfoModalVisible] = React.useState(false);

  const [couponModal, setCouponModal] = React.useState(false);

  const [cancelSubscriptionModalVisible, setCancelSubscriptionModalVisible] =
    React.useState(false);
  const [cancelSubscriptionDate, setCancelSubscriptionDate] = React.useState(
    moment().add(1, "days")
  );
  const [subscriptionType, setSubscriptionType] = React.useState("immediate");
  const [availableTags, setAvailableTags] = React.useState([]);
  const isInitialMount = useRef(true);

  const showToast = useShowToast();

  const pressFilter = async () => {
    getUserPlanStatuses();
    getUserPlanTypes();
    try {
      const tags = await getTags(false);
      setAvailableTags(tags);
    } catch (e) {
      console.error("Failed to fetch tags:", e);
    }
  };

  const hideFilter = () => {
    setFilterVisible(false);
    clearUserData();
  };

  const showUserModal = () => setUserInfoModalVisible(true);
  const hideUserModal = () => setUserInfoModalVisible(false);
  const showCancelSubscriptionModal = () =>
    setCancelSubscriptionModalVisible(true);
  const closeCouponModal = () => setCouponModal(false);
  const showCouponModal = () => setCouponModal(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (id && !adminDetails?.newBackendEnabled) {
      changeSearch({ target: { value: id } });
    }
  }, [id, adminDetails?.newBackendEnabled, changeSearch]);

  useEffect(() => {
    if (deleteCouponByIdSuccess === true) {
      showToast("Coupon removed", "success");
      dispatch(clearCreateCoupon());
    }
  }, [deleteCouponByIdSuccess]);

  useEffect(() => {
    if (getCouponListByUserSuccess === true) {
      dispatch(clearCreateCoupon());
      showCouponModal();
    }
  }, [getCouponListByUserSuccess]);

  useEffect(() => {
    if (getPlanTypesSuccess) {
      setFilterVisible(true);
    }
  }, [getPlanTypesSuccess]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (getUserSuccess) {
      showUserModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getUserSuccess]);

  useEffect(() => {
    if (filterProps?.filterValue) {
      setFilterValues(filterProps?.filterValue || []);
    }
  }, [filterProps]);

  useEffect(() => {
    if (updateUserSuccess) {
      showToast("Success", "success");
      clearUser();
      hideUserModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserSuccess, clearUser]);

  useEffect(() => {
    if (cancelSubscriptionSuccess) {
      showToast("Success", "success");
      closeCancelSubscriptionModal();
      setSelectedUser(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelSubscriptionSuccess]);

  const closeUserModal = () => {
    hideUserModal();
    clearUser();
  };

  const closeCancelSubscriptionModal = () => {
    setCancelSubscriptionModalVisible(false);
  };

  const hideDialog = React.useCallback(() => {
    setConfirmDialogVisible(false);
    setSelectedUser(null);
  }, [setConfirmDialogVisible]);

  const showDialog = React.useCallback(() => {
    setConfirmDialogVisible(true);
  }, [setConfirmDialogVisible]);

  const handleChangePage = React.useCallback(
    (event, newPage) => {
      changePage(newPage);
    },
    [changePage]
  );

  const selectMenu = React.useCallback(
    (event) => {
      switch (event.action) {
        case REMOVE_USER:
          showDialog();
          setSelectedUser(event.client);
          break;
        case CANCEL_SUBSCRIPTION:
          showCancelSubscriptionModal();
          setSelectedUser(event.client);
          break;
        case SHOW_LEDGER:
          setSelectedUser(event.client);
          navigate(
            `/dashboard/ledger/${event.client.id}/${event.client?.plan?.cityId}`
          );
          break;
        case SHOW_COUPON:
          dispatch(
            getAllCouponByUserId(event.client.id, event.client?.plan?.cityId)
          );
          setSelectedUser(event.client);
          break;
        case BLOCK_USER:
          setSelectedUser(event.client);
          if (event.client?.status === "BLOCKED") {
            setUnblockModalVisible(true);
          } else {
            setBlockModalVisible(true);
          }
          break;
        default:
          break;
      }
    },
    [showDialog, setSelectedUser]
  );

  const removeUser = React.useCallback(() => {
    props.removeUser(selectedUser.id);
    hideDialog();
  }, [selectedUser, props, hideDialog]);

  const handleCancelSubscriptionRequest = React.useCallback(() => {
    if (subscriptionType === "date" && selectedUser) {
      props.cancelSubscription(
        selectedUser?.plan?.cityId,
        selectedUser?.id,
        selectedUser?.plan?.id,
        moment(cancelSubscriptionDate).format("X")
      );
    } else if (subscriptionType === "immediate" && selectedUser) {
      props.cancelSubscription(
        selectedUser?.plan?.cityId,
        selectedUser?.id,
        selectedUser?.plan?.id,
        ""
      );
    }
  }, [selectedUser, props, cancelSubscriptionDate, subscriptionType]);

  const applyFilter = React.useCallback(() => {
    setFilterVisible(false);
    clearUserData();
    filterProps.setFilterValue(filterValues);
  }, [filterValues, filterProps, clearUserData]);

  const changeSelectorValue = React.useCallback(
    (filter, filterBy) => {
      const isEmpty =
        filter === "" ||
        (Array.isArray(filter) && filter.length === 0) ||
        (filter &&
          typeof filter === "object" &&
          Array.isArray(filter.ids) &&
          filter.ids.length === 0);

      if (
        filterValues.filter((item) => item.filterBy === filterBy).length > 0
      ) {
        if (isEmpty) {
          setFilterValues(
            filterValues?.filter((item) => item.filterBy !== filterBy)
          );
        } else {
          setFilterValues(
            filterValues.map((item) => {
              if (item.filterBy === filterBy) {
                return { filter, filterBy };
              }
              return item;
            })
          );
        }
      } else {
        setFilterValues([...filterValues, { filter, filterBy }]);
      }
    },
    [filterValues, setFilterValues]
  );

  const removeFilter = React.useCallback(
    (indexValue) => {
      const filterValues = filterProps.filterValue.filter(
        (item, index) => index !== indexValue
      );
      filterProps.setFilterValue(
        filterValues?.length > 0 ? filterValues : null
      );
      setFilterValues(filterValues);
    },
    [filterProps]
  );

  const tagFilter = React.useMemo(() => {
    const tagFilterItem = filterProps.filterValue?.find(
      (f) => f.filterBy === "tagId"
    );
    return tagFilterItem?.filter || null;
  }, [filterProps.filterValue]);

  const renderClientList = React.useCallback(
    () => (
      <ClientItem
        clients={props.clients}
        selectMenu={selectMenu}
        clientsResult={props.clientsResult}
        handleChangePage={handleChangePage}
        orderProps={orderProps}
        cities={citiesList}
        tagFilter={tagFilter}
        tagFilterTotalCount={tagFilterTotalCount}
        currentPageValue={currentPageValue}
      />
    ),
    [
      selectMenu,
      props,
      handleChangePage,
      orderProps,
      citiesList,
      tagFilter,
      tagFilterTotalCount,
      currentPageValue,
    ]
  );

  const dialogTitle = React.useMemo(
    () =>
      selectedUser?.fullName
        ? strings("message.removeUserWithName", { user: selectedUser.fullName })
        : strings("message.removeUser"),
    [selectedUser]
  );

  const content = () => (
    <>
      <SearchBlock
        title={strings("title.users")}
        searchValue={searchValue}
        onChange={changeSearch}
        clear={clearSearchValue}
        pressFilter={pressFilter}
        removeFilter={removeFilter}
        filterProps={filterProps.filterValue}
        tagOptions={availableTags}
      />
      {props.clients?.length > 0 || user?.length > 0 ? (
        <div className={"dashboardList"}>{renderClientList()}</div>
      ) : (
        <p className={"emptyResultText"}>{strings("message.noUsers")}</p>
      )}
      <ConfirmationDialog
        visibility={confirmDialogVisible}
        hideDialog={hideDialog}
        title={dialogTitle}
        positiveAction={removeUser}
        negativeAction={hideDialog}
      />
      <ClientModal
        visible={userInfoModalVisible}
        closeUserModal={closeUserModal}
        client={user}
        updateUser={updateUser}
      />
      <ClientFilter
        apply={applyFilter}
        cancel={hideFilter}
        visible={filterVisible}
        hideFilter={hideFilter}
        changeSelectorValue={changeSelectorValue}
        filterProps={filterValues}
        types={planTypes}
        statuses={planStatuses}
        tags={availableTags}
      />
      <CancelSubscriptionModal
        visible={cancelSubscriptionModalVisible}
        cancelSubscriptionDate={cancelSubscriptionDate}
        setCancelSubscriptionDate={setCancelSubscriptionDate}
        handleCancelSubscriptionRequest={handleCancelSubscriptionRequest}
        subscriptionType={subscriptionType}
        setSubscriptionType={setSubscriptionType}
        closeCancelSubscriptionModal={closeCancelSubscriptionModal}
      />

      <PreviewCouponModal
        open={couponModal}
        onClose={closeCouponModal}
        getCouponListByUser={getCouponListByUser}
        selectedUser={selectedUser}
      />

      {adminDetails?.newBackendEnabled && (
        <>
          <BlockUserModal
            open={blockModalVisible}
            onClose={() => {
              setBlockModalVisible(false);
              setSelectedUser(null);
            }}
            userId={selectedUser?.id?.toString()}
            userName={selectedUser?.fullName || "User"}
            adminEmail={getCurrentUser()?.email || ""}
            onSuccess={() => {
              props.refreshClients?.();
            }}
          />
          <UnblockUserModal
            open={unblockModalVisible}
            onClose={() => {
              setUnblockModalVisible(false);
              setSelectedUser(null);
            }}
            userId={selectedUser?.id?.toString()}
            userName={selectedUser?.fullName || "User"}
            adminEmail={getCurrentUser()?.email || ""}
            currentReason={selectedUser?.blockReason}
            onSuccess={() => {
              props.refreshClients?.();
            }}
          />
        </>
      )}
    </>
  );

  const loading = () => <Loader />;

  return (
    <div className={"dashboardContent"}>
      {getClientsSuccess ? content() : loading()}
    </div>
  );
}

const mapStateToProps = ({
  users: {
    clients,
    clientsResult,
    getUserSuccess,
    user,
    updateUserSuccess,
    getPlanTypesSuccess,
    planTypes,
    planStatuses,
    getClientsSuccess,
    cancelSubscriptionSuccess,
  },
  cities: {
    citiesList,
    getCouponListByUser,
    getCouponListByUserSuccess,
    deleteCouponByIdSuccess,
  },
  screen: { passedParams },
  auth: { adminDetails },
}) => ({
  clients,
  clientsResult,
  citiesList,
  getUserSuccess,
  user,
  updateUserSuccess,
  getPlanTypesSuccess,
  planTypes,
  planStatuses,
  getClientsSuccess,
  passedParams,
  cancelSubscriptionSuccess,
  getCouponListByUser,
  getCouponListByUserSuccess,
  deleteCouponByIdSuccess,
  adminDetails,
});

const mapDispatchToProps = {
  removeUser,
  clearUser,
  updateUser,
  getUserPlanStatuses,
  getUserPlanTypes,
  clearUserData,
  getUser,
  emptyPassedParams,
  setSearchValue,
  cancelSubscription,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientContainer);
